export const getTotalPrintCount = () =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/print/getPrintTotalNum");

export const getPackageList = (data:any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/print/getNewPrintList",data);

export const getHistoryNum = (data:any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/print/getHistoryNum",data);

export const getPrintGetHistoryDetail = (data:any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/print/getHistoryDetail",data);

export const getPrintNo = (data:any)=>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/print/getPrintNo",data);

export const getOrgInfo = (data:any)=>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/getOrgInfo",data);

export const saveBagOrg = (data:any)=>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/saveBagOrg",data);

export const HbPrint = (data:any)=>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/newPrint/HbPrint",data);

export const getDeviceLattice = ()=>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/print/getDeviceLattice");

export const queryOrgInfo = (data:any)=>
  JSON.parse(obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/queryOrgInfo",JSON.stringify(data)));

export const queryUserInfo = (data:any)=>
  JSON.parse(obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/queryMonitorEmployee",JSON.stringify(data)));

export const hbPrintList = (data:any)=>
  JSON.parse(obj_HttpRequest_Core.post("/Yto_BusiGateway/newPrint/hbPrintList",JSON.stringify(data)));

export const queryMessageRemind = (data: any) =>
  JSON.parse(obj_HttpRequest_Core.post("/Yto_MonitorGateway/mqtt/messageRemind/clientMsgUnRead", JSON.stringify(data)));

export const updateMessageRemind = (data: any) =>
  JSON.parse(obj_HttpRequest_Core.post("/Yto_MonitorGateway/mqtt/messageRemind/clientMsgRead", JSON.stringify(data)));
